// Copy and member code handling. Kept separate so both the real and mock data
// layers can use it without importing each other.

// Codes are uppercase with hyphens. Scanners and phone keyboards both introduce
// stray whitespace and case; a typed code must never fail for that reason.
export function normaliseCode(raw) {
  return String(raw || '').trim().toUpperCase().replace(/\s+/g, '');
}
